
import netteForms from 'nette-forms';
window.Nette = netteForms;

// Json
Nette.validators['AppFormsValidator_validateJson'] = (elem, args, val) => {
	try {
		JSON.parse(val);
	}
	catch(err) {
		return false;
	}

	return true;
};

Nette.validators['AppFormsValidator_validateJsonMaxLength'] = (elem, args, val) => {
	return val.length <= args;
};

// Wysiwyg
if (typeof tinymce === 'object') {
	tinymce.init({
		selector: "textarea[data-type=\"text:wysiwyg\"]",
		language: document.getElementsByTagName('html')[0].getAttribute('lang'),
		menubar:  false,
		extended_valid_elements: "span",
		entity_encoding : "named",
		entities: '160,nbsp,38,amp,60,lt,62,gt',
		plugins:  "link code lists",
		// toolbar:  "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link removeformat code",
		toolbar:  "undo redo | bold bullist link removeformat code",
		setup:    function (editor) {
			editor.on('change', function (e) {
				document.getElementById(editor.id).value = editor.getContent();
			});
		}
	});
}

// Image preview
if (typeof $ === 'function') {
	$('label.file-preview').each(function () {
		var $filePreview = $(this);
		$('#' + $filePreview.attr('for')).change(function (event) {
			var $image, $span, spantext, file;
			$image = $filePreview.find('img');
			if ($image.length === 0) {
				$image = $('<img>');
				$filePreview.append($image);
			}
			if (event.target.files.length > 0) {
				$filePreview.find('source').remove();
				file = new File([event.target.files[0]], event.target.files[0].name);
				$image.attr('src', URL.createObjectURL(file));
			}
			else { $image.remove(); }
			$span = $filePreview.find('span');
			spantext = $span.html();
			$span.remove();
			$filePreview.append('<span> ' + spantext + '</span>');
		});
	});
}

// Default datetime picker
if (typeof $ === 'function' && typeof $.datetimepicker === 'object') {
	$.datetimepicker.setLocale($('html').attr('lang'));

	$('input[data-type=\"datetime\"]').datetimepicker({
		format:     'Y-m-d H:i',
		formatDate: 'Y-m-d',
	});
}

// Default color picker
if (typeof $ === 'function' && typeof $.spectrum === 'object') {
	// Other options http://bgrins.github.io/spectrum/
	$("input[data-type=color][required]").spectrum({
		// color: tinycolor,
		// flat: true,
		showInput: true,
		showInitial: true,
		cancelText: 'Zrušit',
		chooseText: 'Vybrat',
		containerClassName: 'colorpicker-container',
		replacerClassName: 'colorpicker-replacer',
		preferredFormat: 'hex',
	});

	$("input[data-type=color]:not([required])").spectrum({
		// color: tinycolor,
		// flat: true,
		allowEmpty: true,
		showInput: true,
		showInitial: true,
		cancelText: 'Zrušit',
		chooseText: 'Vybrat',
		clearText: 'Bez barvy',
		containerClassName: 'colorpicker-container',
		replacerClassName: 'colorpicker-replacer',
		preferredFormat: 'hex',
	});
}
